export default "__VITE_ASSET__GrpTkZng__"